/** Label for a saas-auth hostname type (TMMPDM-0018); an unknown value renders raw. */
import { useCopy } from '@/hooks/useCopy';
import type { HostnameType } from '@/api/tmm/types';

const HOSTNAME_TYPES: readonly HostnameType[] = ['APP', 'LOGIN', 'AUTH', 'API', 'ASSET', 'BRAND'];

export function useHostnameTypeLabel(): (type: string) => string {
  const { t } = useCopy();
  return (type) =>
    (HOSTNAME_TYPES as readonly string[]).includes(type)
      ? t(`whitelabel.type.${type}`, type)
      : type;
}
